import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import '../../styles.scss'
import { SingleCheckbox } from '../../../../ui/molecules/SingleCheckbox'
import { InspectionVisitCreation, InspectionVisitTurnOver, resetTurnOverStatus, setIVCreationActivity, setIVCreationActivityTypes, setIVCreationAnnualControlPlaneDetailId, setIVCreationAssignmentId, setIVCreationAuditedActivities, setIVCreationBioNotificationId, setIVCreationControlDetail, setIVCreationCustomerId, setIVCreationDocumentalControl, setIVCreationExpertSubject, setIVCreationExpirationDate, setIVCreationExpirationDateExtended, setIVCreationFirstEnvelope, setIVCreationFourthEnvelope, setIVCreationInAccompanyingSubject, setIVCreationInAccompanyingSubjectEntity, setIVCreationInLocoControl, setIVCreationInSupportSubject, setIVCreationInSupportSubjectEntity, setIVCreationLicenseeOperator, setIVCreationMaterialType, setIVCreationMode, setIVCreationOfficerId, setIVCreationPlannedSampling, setIVCreationRemoteVisit, setIVCreationSecondEnvelope, setIVCreationSpecification, setIVCreationThirdEnvelope, setIVCreationTraineeTechnician, setIVCreationType } from '../../slice'
import { IVActivityTypeEnum, IVAuditedActivityEnum } from '../../dataservice/dto'
import { SelectCustom } from '../../../../ui/molecules/select'
import { IVActivityOptions, IVModeOptions, IVTypeOptions, optionsFormatter, OptionType, PACVisitingTypeOptions } from '../../../../utils'
import InputMultiSearch from '../../../../ui/molecules/input/InputMultiSearch'
import { GetAllPacDetails, GetPacDetailById, resetGetAllPACDetailsStatus, resetGetPACDetailByIdStatus } from '../../../gestioneControllo/pac/slice'
import { Calendar } from '../../../../ui/molecules/calendar'
import { InfoBox } from '../../../../ui/molecules/infoBox'
import TextArea from '../../../../ui/molecules/textArea'
import { GetAllNotification, resetGetAllNotificationStatus } from '../../../notifiche/slice'
import Input from '../../../../ui/molecules/input'
import Button from '../../../../ui/molecules/button'
import { handlePeriodicity } from '../../../gestioneControllo/pac/utils'
import { getOptions } from '../../utils'
import { ServiceTypeNormEnum } from '../../../schedaCalcolo/dataService/dto'

interface Props {
    close: () => void
}

export function InspectionVisitAddPopup(props: Props) {
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const pacState = useAppSelector(state => state.pac)
    const notificationState = useAppSelector(state => state.notification)
    const userState = useAppSelector(state => state.users)
    const [bioHarvFlag, setBioHarv] = useState<boolean>(false)
    const [demeterFlag, setDemeterFlag] = useState<boolean>(false)
    const [bioSuisseFlag, setBioSuisseFlag] = useState<boolean>(false)
    const [pacOptions, setPacOptions] = useState<OptionType[]>([])
    const [locoControlFlag, setLocoControlFlag] = useState<boolean>(false)
    const [documentalControlFlag, setDocumentalControlFlag] = useState<boolean>(false)
    const [remoteVisitFlag, setRemoteVisitFlag] = useState<boolean>(false)
    const [vegetalFlag, setVegetalFlag] = useState<boolean>(false)
    const [zootecniaFlag, setZootecniaFlag] = useState<boolean>(false)
    const [acquacolturaFlag, setAcquacolturaFlag] = useState<boolean>(false)
    const [vitivinicoloFlag, setVitivinicoloFlag] = useState<boolean>(false)
    const [sementerioFlag, setSementerioFlag] = useState<boolean>(false)
    const [mangimiFlag, setMangimiFlag] = useState<boolean>(false)
    const [gdoFlag, setGdoFlag] = useState<boolean>(false)
    const [licenseeOperatorFlag, setLicenseeOperatorFlag] = useState<boolean>(false)
    const [notifications, setNotifications] = useState<OptionType[]>([])
    const [plannedSamplingFlag, setPlannedSamplingFlag] = useState<boolean>(false)
    const [turnOver, setTurnOver] = useState<string>('')

    useEffect(() => {
        dispatch(setIVCreationAssignmentId(assignmentState.assignmentIdToUpdate))
        dispatch(setIVCreationOfficerId(userState.findMeResponse.id))

    }, [])

    useEffect(() => {
        if (assignmentState.inspectionVisitCreationRequest.customerId !== undefined && assignmentState.inspectionVisitCreationRequest.customerId) {
            dispatch(GetAllPacDetails({
                itemsPerPage: 0,
                page: 0,
                customerId: assignmentState.inspectionVisitCreationRequest.customerId,
                searchForAssignment: true
            }))
            dispatch(GetAllNotification({
                itemsPerPage: 0,
                page: 0,
                customerId: assignmentState.inspectionVisitCreationRequest.customerId
            }))

            if (assignmentState.getAssignmentByIdResponse?.inspectorCode && assignmentState.inspectionVisitCreationRequest.customerId !== undefined) {
                dispatch(
                    InspectionVisitTurnOver({
                        inspectorCode: assignmentState.getAssignmentByIdResponse?.inspectorCode,
                        customerId: assignmentState.inspectionVisitCreationRequest.customerId
                    }))
            }
        }

    }, [assignmentState.inspectionVisitCreationRequest.customerId])

    useEffect(() => {
        if (assignmentState.inspectionVisitTurnOverStatus === 'successfully') {
            dispatch(resetTurnOverStatus())
            if (assignmentState.turnOverResponse?.message === 'PRIMA_VISITA') {
                setTurnOver("Prima visita presso il cliente da parte dell'ispettore "+ assignmentState.getAssignmentByIdResponse?.personalManagementInfo)
            }
            if (assignmentState.turnOverResponse?.message === 'SECONDA_VISITA') {
                 setTurnOver("Seconda visita consecutiva presso il cliente da parte dell'ispettore "+ assignmentState.getAssignmentByIdResponse?.personalManagementInfo)
            }
            if (assignmentState.turnOverResponse?.message === 'TERZA_VISITA') {
                 setTurnOver("Attenzione! Terza visita presso il cliente da parte dell'ispettore "+ assignmentState.getAssignmentByIdResponse?.personalManagementInfo)
            }
             if (assignmentState.turnOverResponse?.message === 'BLOCCO') {
                setTurnOver('Non sono ancora passati 2 anni dalle ultime 3 visite consecutive')
            }
        }
    }, [assignmentState.inspectionVisitTurnOverStatus])

    useEffect(() => {
        if (pacState.getAllPACDetailsStatus === 'successfully' &&
            pacState.getAllPACDetailsResponse !== undefined
        ) {
            dispatch(resetGetAllPACDetailsStatus())
            const data = pacState.getAllPACDetailsResponse.data.map(pac => {

                return {
                    value: pac.id,
                    label: `PAC: ${pac.annualControlPlaneDTO.year} - Data fine: ${pac.annualControlPlaneDTO.endingDate} - Periodo: ${handlePeriodicity(pac.periodicity)} - Tipo visita: ${optionsFormatter(pac.visitType, PACVisitingTypeOptions)} - Prelievo: ${pac.sampling ? 'Sì' : 'No'}`
                } as OptionType
            })
            setPacOptions(data)
        }
    }, [pacState.getAllPACDetailsStatus])

    useEffect(() => {
        if (assignmentState.inspectionVisitCreationRequest.annualControlPlaneDetailId) {
            const selectedPac = pacState.getAllPACDetailsResponse?.data.find(
                pac => pac.id === assignmentState.inspectionVisitCreationRequest.annualControlPlaneDetailId
            );
            if (selectedPac) {
                dispatch(setIVCreationMode(selectedPac.mode))
                dispatch(setIVCreationType(selectedPac.visitType))
                dispatch(setIVCreationPlannedSampling(selectedPac.sampling))
                setPlannedSamplingFlag(selectedPac.sampling)
                dispatch(setIVCreationSpecification(selectedPac.specifications))
                dispatch(GetPacDetailById(assignmentState.inspectionVisitCreationRequest.annualControlPlaneDetailId))
            }
        }

    }, [assignmentState.inspectionVisitCreationRequest.annualControlPlaneDetailId])

    useEffect(() => {
        if (pacState.getPACDetailByIdStatus === 'successfully' &&
            pacState.getPACDetailByIdResponse !== undefined
        ) {
            dispatch(resetGetPACDetailByIdStatus())
            dispatch(setIVCreationControlDetail(pacState.getPACDetailByIdResponse?.specifications))
        }
    }, [pacState.getPACDetailByIdStatus])

    useEffect(() => {
        if (notificationState.getAllNotificationStatus === 'successfully' &&
            notificationState.getAllNotificationResponse
        ) {
            dispatch(resetGetAllNotificationStatus())
            const data = notificationState.getAllNotificationResponse.data.map(n => {
                return {
                    value: n.id,
                    label: `Notifica n.${n.identifier} del ${n.releaseDate}`
                } as OptionType
            })
            setNotifications(data)
        }
    }, [notificationState.getAllNotificationStatus])

    useEffect(() => {
        if (assignmentState.inspectionVisitCreationStatus === 'successfully') {
            props.close()
        }
    }, [assignmentState.inspectionVisitCreationStatus])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>

                <div className="pb-3">
                    <div className="text-left assignment-text-content">
                        Seleziona cliente
                    </div>
                    <InputMultiSearch
                        searchOne
                        onSelectAddHandler={(res) => dispatch(setIVCreationCustomerId(res[0]))}
                    />
                </div>

                <div className="pb-3" style={{ borderBottom: '1px solid #d9e6e8' }}>
                    <div className="text-left assignment-text-content">
                        Seleziona PAC per il cliente
                    </div>
                    <SelectCustom
                        disabled={pacOptions.length < 1}
                        placeholder='Seleziona PAC...'
                        options={pacOptions}
                        value={assignmentState.inspectionVisitCreationRequest.annualControlPlaneDetailId}
                        onChange={(value) => {
                            dispatch(setIVCreationAnnualControlPlaneDetailId(value))
                        }}
                    />
                    {
                        turnOver != '' && (
                            <div className='mt-3'>
                                <div className='pb-1 assignment-title'>
                                    <span className='sectionTitle' style={{fontSize: '20px'}}>{turnOver}</span>
                                </div>
                            </div>
                        )
                    }
                </div>

                <div className="pb-1 pt-3 text-left assignment-subtitle">
                    Tipo di Controllo
                </div>

                <div className="ml-1 pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Controllo in Loco
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={locoControlFlag}
                            setChecked={(value) => {
                                dispatch(setIVCreationInLocoControl(value))
                                setLocoControlFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Controllo Documentale
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={documentalControlFlag}
                            setChecked={(value) => {
                                dispatch(setIVCreationDocumentalControl(value))
                                setDocumentalControlFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Controllo da remoto
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={remoteVisitFlag}
                            setChecked={(value) => {
                                dispatch(setIVCreationRemoteVisit(value))
                                setRemoteVisitFlag(value)
                            }}
                        />
                    </div>
                </div>

                <div className="pb-1 text-left assignment-subtitle">
                    Attività oggetto di controllo
                </div>

                <div className="ml-1 pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Agricoltura Biologica
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={bioHarvFlag}
                            setChecked={(value) => {
                                let newActTypes: IVAuditedActivityEnum[] = [...assignmentState.inspectionVisitCreationRequest.auditedActivities]
                                if (value && !newActTypes.includes(IVAuditedActivityEnum.AGRICOLTURA_BIOLOGICA)) {
                                    newActTypes.push(IVAuditedActivityEnum.AGRICOLTURA_BIOLOGICA)
                                }
                                else if (!value && newActTypes.includes(IVAuditedActivityEnum.AGRICOLTURA_BIOLOGICA)) {
                                    newActTypes = newActTypes.filter(a => a !== IVAuditedActivityEnum.AGRICOLTURA_BIOLOGICA)
                                }
                                dispatch(setIVCreationAuditedActivities(newActTypes))
                                setBioHarv(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Demeter
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={demeterFlag}
                            setChecked={(value) => {
                                let newActTypes: IVAuditedActivityEnum[] = [...assignmentState.inspectionVisitCreationRequest.auditedActivities]
                                if (value && !newActTypes.includes(IVAuditedActivityEnum.DEMETER)) {
                                    newActTypes.push(IVAuditedActivityEnum.DEMETER)
                                }
                                else if (!value && newActTypes.includes(IVAuditedActivityEnum.DEMETER)) {
                                    newActTypes = newActTypes.filter(a => a !== IVAuditedActivityEnum.DEMETER)
                                }
                                dispatch(setIVCreationAuditedActivities(newActTypes))
                                setDemeterFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Agricoltura Biologica
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={bioSuisseFlag}
                            setChecked={(value) => {
                                let newActTypes: IVAuditedActivityEnum[] = [...assignmentState.inspectionVisitCreationRequest.auditedActivities]
                                if (value && !newActTypes.includes(IVAuditedActivityEnum.BIO_SUISSE)) {
                                    newActTypes.push(IVAuditedActivityEnum.BIO_SUISSE)
                                }
                                else if (!value && newActTypes.includes(IVAuditedActivityEnum.BIO_SUISSE)) {
                                    newActTypes = newActTypes.filter(a => a !== IVAuditedActivityEnum.BIO_SUISSE)
                                }
                                dispatch(setIVCreationAuditedActivities(newActTypes))
                                setBioSuisseFlag(value)
                            }}
                        />
                    </div>
                </div>

                <div className='pb-3'>
                    <div className="text-left assignment-subtitle">
                        Attività
                    </div>
                    <SelectCustom
                        placeholder='Seleziona attività...'
                        options={IVActivityOptions}
                        value={assignmentState.inspectionVisitCreationRequest.activity}
                        onChange={(value) => {
                            dispatch(setIVCreationActivity(value))
                        }}
                    />
                </div>

                <div className="ml-1 pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap', borderBottom: '1px solid #d9e6e8' }}>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Vegetale
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={vegetalFlag}
                            setChecked={(value) => {
                                let newActTypes: IVActivityTypeEnum[] = [...assignmentState.inspectionVisitCreationRequest.activityTypes]
                                if (value && !newActTypes.includes(IVActivityTypeEnum.VEGETALE)) {
                                    newActTypes.push(IVActivityTypeEnum.VEGETALE)
                                }
                                else if (!value && newActTypes.includes(IVActivityTypeEnum.VEGETALE)) {
                                    newActTypes = newActTypes.filter(a => a !== IVActivityTypeEnum.VEGETALE)
                                }
                                dispatch(setIVCreationActivityTypes(newActTypes))
                                setVegetalFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Zootecnia
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={zootecniaFlag}
                            setChecked={(value) => {
                                let newActTypes: IVActivityTypeEnum[] = [...assignmentState.inspectionVisitCreationRequest.activityTypes]
                                if (value && !newActTypes.includes(IVActivityTypeEnum.ZOOTECNIA)) {
                                    newActTypes.push(IVActivityTypeEnum.ZOOTECNIA)
                                }
                                else if (!value && newActTypes.includes(IVActivityTypeEnum.ZOOTECNIA)) {
                                    newActTypes = newActTypes.filter(a => a !== IVActivityTypeEnum.ZOOTECNIA)
                                }
                                dispatch(setIVCreationActivityTypes(newActTypes))
                                setZootecniaFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Acquacoltura
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={acquacolturaFlag}
                            setChecked={(value) => {
                                let newActTypes: IVActivityTypeEnum[] = [...assignmentState.inspectionVisitCreationRequest.activityTypes]
                                if (value && !newActTypes.includes(IVActivityTypeEnum.ACQUACOLTURA)) {
                                    newActTypes.push(IVActivityTypeEnum.ACQUACOLTURA)
                                }
                                else if (!value && newActTypes.includes(IVActivityTypeEnum.ACQUACOLTURA)) {
                                    newActTypes = newActTypes.filter(a => a !== IVActivityTypeEnum.ACQUACOLTURA)
                                }
                                dispatch(setIVCreationActivityTypes(newActTypes))
                                setAcquacolturaFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Vitivinicolo
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={vitivinicoloFlag}
                            setChecked={(value) => {
                                let newActTypes: IVActivityTypeEnum[] = [...assignmentState.inspectionVisitCreationRequest.activityTypes]
                                if (value && !newActTypes.includes(IVActivityTypeEnum.VITIVINICOLO)) {
                                    newActTypes.push(IVActivityTypeEnum.VITIVINICOLO)
                                }
                                else if (!value && newActTypes.includes(IVActivityTypeEnum.VITIVINICOLO)) {
                                    newActTypes = newActTypes.filter(a => a !== IVActivityTypeEnum.VITIVINICOLO)
                                }
                                dispatch(setIVCreationActivityTypes(newActTypes))
                                setVitivinicoloFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Sementerio
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={sementerioFlag}
                            setChecked={(value) => {
                                let newActTypes: IVActivityTypeEnum[] = [...assignmentState.inspectionVisitCreationRequest.activityTypes]
                                if (value && !newActTypes.includes(IVActivityTypeEnum.SEMENTIERO)) {
                                    newActTypes.push(IVActivityTypeEnum.SEMENTIERO)
                                }
                                else if (!value && newActTypes.includes(IVActivityTypeEnum.SEMENTIERO)) {
                                    newActTypes = newActTypes.filter(a => a !== IVActivityTypeEnum.SEMENTIERO)
                                }
                                dispatch(setIVCreationActivityTypes(newActTypes))
                                setSementerioFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Mangimi
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={mangimiFlag}
                            setChecked={(value) => {
                                let newActTypes: IVActivityTypeEnum[] = [...assignmentState.inspectionVisitCreationRequest.activityTypes]
                                if (value && !newActTypes.includes(IVActivityTypeEnum.MANGIMI)) {
                                    newActTypes.push(IVActivityTypeEnum.MANGIMI)
                                }
                                else if (!value && newActTypes.includes(IVActivityTypeEnum.MANGIMI)) {
                                    newActTypes = newActTypes.filter(a => a !== IVActivityTypeEnum.MANGIMI)
                                }
                                dispatch(setIVCreationActivityTypes(newActTypes))
                                setMangimiFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Punto Vendita GDO
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={gdoFlag}
                            setChecked={(value) => {
                                let newActTypes: IVActivityTypeEnum[] = [...assignmentState.inspectionVisitCreationRequest.activityTypes]
                                if (value && !newActTypes.includes(IVActivityTypeEnum.PUNTO_VENDITA_GDO)) {
                                    newActTypes.push(IVActivityTypeEnum.PUNTO_VENDITA_GDO)
                                }
                                else if (!value && newActTypes.includes(IVActivityTypeEnum.PUNTO_VENDITA_GDO)) {
                                    newActTypes = newActTypes.filter(a => a !== IVActivityTypeEnum.PUNTO_VENDITA_GDO)
                                }
                                dispatch(setIVCreationActivityTypes(newActTypes))
                                setGdoFlag(value)
                            }}
                        />
                    </div>
                </div>

                <div className='pb-3 pt-3' style={{ borderBottom: '1px solid #d9e6e8' }}>
                    <div className='text-left assignment-subtitle'>
                        Ultimo certificato di conformità
                    </div>
                    <div className='text-left assignment-text-content'>
                        Certificato di conformità n. IT BIO 002 M006 00803456 del 20/05/2025
                    </div>
                </div>

                <div className='pb-3 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="text-left assignment-text-content">
                            Tipo visita
                        </div>
                        <SelectCustom
                            placeholder='Seleziona tipo...'
                            options={getOptions(ServiceTypeNormEnum.NORMA_BIO)}
                            value={assignmentState.inspectionVisitCreationRequest.type}
                            //value={pacState.getPACDetailByIdResponse?.visitType}
                            onChange={(value) => {
                                dispatch(setIVCreationType(value))
                            }}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="text-left assignment-text-content">
                            Modalità
                        </div>
                        <SelectCustom
                            placeholder='Seleziona modalità...'
                            options={IVModeOptions}
                            value={assignmentState.inspectionVisitCreationRequest.mode}
                            //value={pacState.getPACDetailByIdResponse?.mode}
                            onChange={(value) => {
                                dispatch(setIVCreationMode(value))
                            }}
                        />
                    </div>
                </div>

                <div className='pb-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="text-left assignment-text-content">
                            Scadenza
                        </div>
                        <Calendar
                            selected={assignmentState.inspectionVisitCreationRequest.expirationDate}
                            onChange={(date) => dispatch(setIVCreationExpirationDate(date))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="text-left assignment-text-content">
                            Data Scadenza prorogata al
                        </div>
                        <Calendar
                            selected={assignmentState.inspectionVisitCreationRequest.expirationDateExtended}
                            onChange={(date) => dispatch(setIVCreationExpirationDateExtended(date))}
                        />
                    </div>
                </div>

                <div className='pb-3' style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                    <div className='text-left assignment-text-content'>
                        Operatore Licenziatario
                    </div>
                    <SingleCheckbox
                        label=''
                        checked={licenseeOperatorFlag}
                        setChecked={(value) => {
                            dispatch(setIVCreationLicenseeOperator(value))
                            setLicenseeOperatorFlag(value)
                        }}
                    />
                </div>

                {/* <div className='pb-3'>
                    <InfoBox
                        title='Dettaglio Controllo Straordinario/Mirato'
                        color='green'
                        freeText={pacState.getPACDetailByIdResponse?.specifications ?
                            { title: null, label: pacState.getPACDetailByIdResponse?.specifications } : undefined
                        }
                    />
                </div> */}

                <div className='pb-3'>
                    <div className='text-left assignment-text-content'>
                        Specifiche
                    </div>
                    <TextArea
                        value={pacState.getPACDetailByIdResponse?.specifications}
                        onChangeText={(text) => dispatch(setIVCreationSpecification(text))}
                    />
                </div>

                <div className='pb-3' style={{ borderBottom: '1px solid #d9e6e8' }}>
                    <div className="text-left assignment-text-content">
                        Notifica oggetto di controllo
                    </div>
                    <SelectCustom
                        disabled={notifications.length < 1}
                        placeholder='Seleziona notifica...'
                        options={notifications}
                        value={assignmentState.inspectionVisitCreationRequest.bioNotificationId}
                        onChange={(value) => {
                            dispatch(setIVCreationBioNotificationId(value))
                        }}
                    />
                </div>

                <div className='pb-3 pt-3' style={{ display: 'flex', gap: '9px', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Prelievo Campioni
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={plannedSamplingFlag}
                            setChecked={(value) => {
                                dispatch(setIVCreationPlannedSampling(value))
                                setPlannedSamplingFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ flex: '1', display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Tipo Materiale
                        </div>
                        <div style={{ flex: '1' }}>
                            <Input
                                onChangeText={(text) => dispatch(setIVCreationMaterialType(text))}
                                disabled={!plannedSamplingFlag}
                            />
                        </div>
                    </div>
                </div>

                <div className='pb-3' style={{ display: 'flex', gap: '24px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                    <div style={{ flex: '1', display: 'flex', gap: '6px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Busta 1
                        </div>
                        <div style={{ flex: '1' }}>
                            <Input
                                onChangeText={(text) => dispatch(setIVCreationFirstEnvelope(text))}
                            />
                        </div>
                    </div>

                    <div style={{ flex: '1', display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Busta 2
                        </div>
                        <div style={{ flex: '1' }}>
                            <Input
                                onChangeText={(text) => dispatch(setIVCreationSecondEnvelope(text))}
                            />
                        </div>
                    </div>

                    <div style={{ flex: '1', display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Busta 3
                        </div>
                        <div style={{ flex: '1' }}>
                            <Input
                                onChangeText={(text) => dispatch(setIVCreationThirdEnvelope(text))}
                            />
                        </div>
                    </div>

                    <div style={{ flex: '1', display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-content'>
                            Busta 4
                        </div>
                        <div style={{ flex: '1' }}>
                            <Input
                                onChangeText={(text) => dispatch(setIVCreationFourthEnvelope(text))}
                            />
                        </div>
                    </div>
                </div>

                <div className='pb-3 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-content'>
                            Soggetto in affiancamento
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setIVCreationInSupportSubject(text))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-content'>
                            Ente
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setIVCreationInSupportSubjectEntity(text))}
                        />
                    </div>
                </div>

                <div className='pb-3 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-content'>
                            Soggetto in accompagnamento
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setIVCreationInAccompanyingSubject(text))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-content'>
                            Ente
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setIVCreationInAccompanyingSubjectEntity(text))}
                        />
                    </div>
                </div>

                <div className='pb-3 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-content'>
                            Soggetto esperto
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setIVCreationExpertSubject(text))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className='text-left assignment-text-content'>
                            Tecnico Tirocinante
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setIVCreationTraineeTechnician(text))}
                        />
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(InspectionVisitCreation(assignmentState.inspectionVisitCreationRequest))}
                    />
                </div>
            </div>
        </div>
    )
}